import { Injectable, NgModule } from '@angular/core';
import { RouteReuseStrategy } from '@angular/router';
import { Globals } from './globals';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';


import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule, HammerGestureConfig, HammerModule, HAMMER_GESTURE_CONFIG} from '@angular/platform-browser';



import { CommonModule } from "@angular/common";
// MODULES IONIC/CORDOVA
// import { StatusBar } from '@ionic-native/status-bar/ngx';

import { WebView } from '@ionic-native/ionic-webview/ngx';
import { IOSFilePicker } from '@ionic-native/file-picker/ngx';
import { ImagePicker, ImagePickerOptions } from '@ionic-native/image-picker/ngx';
import { FileChooser } from '@ionic-native/file-chooser/ngx';
import { FilePath } from '@ionic-native/file-path/ngx';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { Media } from '@ionic-native/media/ngx';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
// import { MediaCapture, MediaFile, CaptureError, CaptureImageOptions } from '@ionic-native/media-capture/ngx';
import { MediaCapture, MediaFile, CaptureError, CaptureImageOptions } from '@awesome-cordova-plugins/media-capture/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
// import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer/ngx';
// import { File } from '@ionic-native/file/ngx';

import { FileTransfer, FileUploadOptions, FileTransferObject } from '@awesome-cordova-plugins/file-transfer/ngx';
import { File } from '@ionic-native/file/ngx/index';


import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from './interceptor';
import { AppAvailability } from '@awesome-cordova-plugins/app-availability/ngx';


import { AdminModule } from './utils/admin/admin.module';
import { AdminService } from './utils/admin/admin.service';


import { HTTP } from '@ionic-native/http/ngx';
// import { FCM } from '@ionic-native/fcm/ngx';
import { AppLauncher } from '@ionic-native/app-launcher/ngx';
import { Network } from '@ionic-native/network/ngx';


import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

declare var require: any
import { ChartModule, HIGHCHARTS_MODULES } from 'angular-highcharts';
import more from 'highcharts/highcharts-more.src';
import solidGauge from 'highcharts/modules/solid-gauge.src';

export function highchartsModules() {
   return [more, solidGauge];
}
import * as Hammer from 'hammerjs';
export class HammerConfig extends HammerGestureConfig {
   overrides = <any>{
   'swipe': { direction: Hammer.DIRECTION_ALL },
   'pinch': { enable: false },
   'rotate': { enable: false }
   };
}




import { SocketSoaTs } from '@app/utils/utils';
import { AdjuntosModule } from './utils/adjuntos/adjuntos.module';
import { InputModule } from './utils/input/input.module';
import { AlertModule } from './utils/alert/alert.module';


// export let myServiceWebSocket = () => {
//    const isExist =  localStorage.getItem('apiJsSimple');

//    console.log(isExist)
//    return isExist ? new WebSocket() : null;
// };



// export let myServiceWebSocket = async () => {
//    let exists = localStorage.getItem('apiJsSimple');
//    while (!exists) {
//       exists = localStorage.getItem('apiJsSimple');

//       await new Promise(resolve => setTimeout(resolve, 1000));
//    }

//    if ( exists ) {
//       console.log('CONECTADO')
//       return new WebSocket();
//    }
// };

@NgModule({
   declarations: [
      AppComponent,
   ],
   entryComponents: [],
   imports: [
      BrowserModule,
      IonicModule.forRoot({
         swipeBackEnabled: false,
         mode: 'ios'
      }),
      AppRoutingModule,
      HttpClientModule,
      BrowserAnimationsModule,
      MatInputModule,
      MatFormFieldModule,
      MatSelectModule,
      MatCheckboxModule,
      ChartModule,
      NgbModule,
      HammerModule,
      CommonModule,
      AdminModule,
      AdjuntosModule,
      InputModule,
      AlertModule
   ],
   providers: [
      SplashScreen,
      HTTP,
      File,
      FileTransfer,
      Camera,
      Media,
      MediaCapture,
      IOSFilePicker,
      ImagePicker,
      FileChooser,
      ScreenOrientation,
      FileOpener,
      FilePath,
      WebView,
      HTTP,
      Network,
      // FCM,
      SocketSoaTs,
      AppLauncher,
      AppAvailability,
      AdminService,
      // {
      //    provide: WebSocket,
      //    useFactory: myServiceWebSocket
      // },
      // WebSocket,
      {
         provide: HAMMER_GESTURE_CONFIG,
         useClass: HammerConfig
      },
      // {  provide: LocationStrategy, useClass: PathLocationStrategy},{
      //    provide: HAMMER_GESTURE_CONFIG,
      //    useClass: HammerConfig
      // },
      {
         provide: RouteReuseStrategy,
         useClass: IonicRouteStrategy
      },


      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      { provide: HIGHCHARTS_MODULES, useFactory: highchartsModules }, // add as factory to your providers
      {
         provide: HTTP_INTERCEPTORS,
         useClass: Interceptor,
         multi: true,
      },

   ],
   bootstrap: [AppComponent]
})

export class AppModule {}
